/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

import { Button, Col, Container, Row } from "react-bootstrap"
import { useSelector } from "react-redux"
import CONSTANT from "../../../../constant"
import { TSyaryoIdoRireki } from "../../../../globalStore/pageStore/syaryoMaster/syaryoRirekiData"
import { RootState } from "../../../../globalStore/rootreducer"
import { ImmutabilityProvider } from "@grapecity/wijmo.react.grid.immutable"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"

import dayjs from "dayjs"
import { useState } from "react"
import UpdateSyaryoIdoRirekiModal from "./UpdateSyaryoIdoRirekiModal"

/**
 * 車輌異動履歴一覧
 * @returns
 */
const SyaryoRirekiRirekiData = () => {
  //#region [selector]
  const syaryoMaster = useSelector(
    (state: RootState) => state.page.syaryoMaster
  )
  //#endregion

  //#region [method]
  //#endregion

  //#region [state]
  const [車輌所属ID, set車輌所属ID] = useState<number>(0)
  const [備考, set備考] = useState<string>("")

  // モーダル
  const [isSyaryoSyozokuModalShow, setIsSyaryoSyozokuModalShow] =
    useState<boolean>(false)

  //#endregion

  //#region [effect]
  //#endregion

  return (
    <>
      <div className="accordion-header">
        車輌異動履歴
        <div className="accordion-description">車輌異動履歴一覧</div>
      </div>
      <div>
        <h5>車輌異動履歴</h5>
        <Container className="register-form" fluid>
          <Row>
            <Col>
              <wjrGrid.FlexGrid {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}>
                <ImmutabilityProvider
                  itemsSource={syaryoMaster.車輌所属リスト}
                />
                <wjrGrid.FlexGridColumn
                  binding="所属開始日"
                  width={120}
                  format="d"
                  header="異動日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyaryoIdoRireki>
                    ) => {
                      const 異動日 = dayjs(context.item.所属開始日).format(
                        "YYYY/MM/DD"
                      )
                      return (
                        <>{wjcCore.Globalize.format(new Date(異動日), "d")}</>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="会社名"
                  width={200}
                  header="会社名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="所属部所コード"
                  header="部所コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="所属部所名"
                  width={200}
                  header="部所名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="担当乗務員名"
                  header="担当乗務員"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={200}
                  header="備考"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車番"
                  width={80}
                  header="車番"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="異動時_登録番号"
                  width={160}
                  header="登録番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="使用者情報_会社名"
                  width={180}
                  header="使用者名称"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車輌営業所区分名称1"
                  width={128}
                  header="車輌営業所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  variant="waiting"
                  header="編集"
                  cssClassAll={"read-only-cell"}
                  allowDragging={false}
                  hasFilter={false}
                  allowSorting={false}
                  binding="車輌所属ID"
                  allowMerging={true}
                  selectable={false}
                  align="center"
                  width={60}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyaryoIdoRireki>
                    ) => {
                      return (
                        <Button
                          type="button"
                          tabIndex={-1}
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            // gridPageHelper.savePageConditionData(
                            //   location.pathname
                            // )
                            set車輌所属ID(context.item.車輌所属ID)
                            set備考(context.item.備考)
                            setIsSyaryoSyozokuModalShow(true)
                          }}>
                          編集
                        </Button>
                      )
                      // }
                    }}
                  />
                </wjrGrid.FlexGridColumn>
              </wjrGrid.FlexGrid>
            </Col>
          </Row>
          {/* 車輌所属モーダル */}
          <UpdateSyaryoIdoRirekiModal
            isShow={isSyaryoSyozokuModalShow}
            setIsShow={setIsSyaryoSyozokuModalShow}
            syaryoSyozokuId={車輌所属ID}
            text={備考}></UpdateSyaryoIdoRirekiModal>
        </Container>
      </div>
    </>
  )
}

export default SyaryoRirekiRirekiData
